

export const idPhotoGeneration = {
    toolName: '證件照生成',
    toolDescription: '將您的照片轉換為標準的證件照，支援多種尺寸和背景顏色',
    
    uploadImage: '上傳照片',
    uploadImageDescription: '上傳一張清晰的人像照片，支援 JPG、PNG 格式',
    clickOrDragUpload: '點擊或拖拽上傳照片',
    
    photoSize: '照片尺寸',
    photoSizeDescription: '選擇您需要的證件照尺寸',
    
    backgroundColor: '背景顏色',
    backgroundColorDescription: '選擇證件照的背景顏色',
    
    sizes: {
      oneInch: {
        name: '一寸照',
        desc: '2.5cm × 3.5cm，常用於身份證、學生證等'
      },
      twoInch: {
        name: '二寸照',
        desc: '3.5cm × 5.3cm，常用於護照、簽證等'
      },
      passport: '護照照片',
      passportDesc: '3.5cm × 4.5cm，符合護照標準尺寸',
      visa: '簽證照片',
      visaDesc: '5.1cm × 5.1cm，符合美國簽證標準'
    },
    
    backgroundColors: {
      title: '背景顏色選擇'
    },
    
    generateButton: '生成證件照',
    generating: '生成中...',
    generationComplete: '證件照生成完成',
    downloadPhoto: '下載證件照',
    
    tips: {
      title: '拍攝建議',
      items: [
        '請使用清晰的正面照片',
        '確保光線充足，避免陰影',
        '保持自然表情，眼睛直視鏡頭',
        '避免佩戴帽子或遮擋面部的飾品'
      ]
    }
  };
